module.exports = __webpack_public_path__ + "img/adresse copy.934be3b0.png";